import { getIn, setIn } from 'formik';
import { z } from 'zod';

/**
 * A formik `validate` function built from a zod schema.
 *
 * formik's own `validationSchema` speaks yup only (it expects a thrown
 * ValidationError with `inner`), so the schema is run here and its issues are
 * mapped onto the nested error object formik reads — `patient.email`,
 * `documents[0].name` — keeping the FIRST message per field, as
 * `abortEarly: false` did.
 */
export const zodValidate =
  <T extends z.ZodType>(schema: T) =>
  (values: unknown) => {
    const result = schema.safeParse(values);

    if (result.success) {
      return {};
    }

    let errors: Record<string, unknown> = {};

    result.error.issues.forEach((issue) => {
      const path = issue.path.join('.');

      if (!path || getIn(errors, path)) {
        return;
      }

      errors = setIn(errors, path, issue.message);
    });

    return errors;
  };
